export default {
  name: "ttUserLanguageDetector",

  lookup(options) {
    // options -> are passed in options
    return "en-GB"
  },

  cacheUserLanguage(lng, options) {
    // options -> are passed in options
    // lng -> current language, will be called after init and on changeLanguage
    // store it
  },
}



// WEBPACK FOOTER //
// ./src/i18n/ttUserLanguageDetector.js